var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"box",staticClass:"flexible-text"},[_c('div',{ref:"resizer",staticClass:"text-resizer",domProps:{"textContent":_vm._s(_vm.value)}}),_vm._v(" "+_vm._s(_vm.localValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }